import styled from 'styled-components';

const TopDiv = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 100;
`;

const SpinnerDiv = styled.div`
  background-color: white;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.09);

  .btn__label {
    margin-right: 10px;
  }

  button, button:hover {
    cursor: default;
  }
`;

export const PanelStyled = {
    TopDiv,
    SpinnerDiv,
};